import { Controller, ColorFrom, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS } from '@framework/workbench/drawer/ui/text/font/font-color/config';
import { Form, ColorOperations } from '@tencent/wb-ext-form';
import { FormItemName } from '@framework/workbench/drawer/constants';
import { convertColor } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/utils/color';
import { getDrawerColorOptions, getRgbaColor } from '@framework/workbench/drawer/utils/color-options';
import { IFontColorFeature } from './font-color-interface';
import { MULTI } from '@src/js/constant';

const DEFAULT_COLOR = '#fefefe';

@Controller({ formItems: FORM_CONFIGS })
export class FormFontColorController {
    constructor(@Loader(IFontColorFeature) private loader: IDynamicLoader<IFontColorFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.FONT_COLOR, 'content')
    public getColorSelectButton(): JSX.Element {
        return this.feature.getColorSelectButton();
    }
}
